import { QueryClient } from '@tanstack/react-query';

/**
 * Central QueryClient configuration for React Query
 *
 * Default configuration:
 * - staleTime: 5 minutes (data considered fresh for 5 min)
 * - gcTime: 10 minutes (unused data removed after 10 min)
 * - refetchOnWindowFocus: true (refetch when user returns to tab)
 * - refetchOnReconnect: true (refetch after network reconnect)
 * - retry: 3 attempts for failed requests
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // How long data is considered fresh (no refetch needed)
            staleTime: 5 * 60 * 1000, // 5 minutes

            // How long unused data stays in cache before garbage collection
            gcTime: 10 * 60 * 1000, // 10 minutes

            // Refetch on window focus (user returns to tab)
            refetchOnWindowFocus: true,

            // Refetch on network reconnect
            refetchOnReconnect: true,

            // Number of retry attempts for failed requests
            retry: 3,

            // Retry delay with exponential backoff
            retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        },
    },
});
